function calculateFontSizeScale() {
  const originalWidth = window.matchMedia("(max-width: 750px)").matches
    ? 750
    : 1920;
  const scaleRatio = window.innerWidth / originalWidth;

  document.body.style.setProperty(
    "--custom-font-size",
    scaleRatio.toFixed(2),
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", calculateFontSizeScale, {
    once: true,
  });
} else {
  calculateFontSizeScale();
}

window.addEventListener("resize", calculateFontSizeScale);